export const SUCCES_HAPPY_HOURS = "SUCCES_HAPPY_HOURS";
export const UPDATE_HAPPY_DAY = "UPDATE_HAPPY_DAY";
export const SUCCESS_UPDATE_HAPPY = "SUCCESS_UPDATE_HAPPY";
export const RESET_HAPPY = "RESET_HAPPY";